<script lang="ts">
	import { toast } from 'svelte-sonner'

	import { Button } from '$lib/components/ui/button'
	import * as m from '$lib/paraglide/messages'
	import { getRandomInteger } from '$lib/utils/numberHelpers'
	import { phg } from '$lib/utils/posthog'
	import Twitter from '~icons/simple-icons/x'

	const variant = getRandomInteger(1, 3)
</script>

<div class="mb-4 flex items-center gap-1">
	<div class="flex items-center justify-center p-3">
		<Twitter class="size-6" height="24" width="24" />
	</div>

	<p>
		{#if variant === 1}
			{m.twitter_banner_text_1()}
		{:else if variant === 2}
			{m.twitter_banner_text_2()}
		{:else}
			{m.twitter_banner_text_3()}
		{/if}
	</p>
</div>

<Button
	class="w-full"
	href="https://x.com/chainspect_app"
	rel="noopener noreferrer"
	target="_blank"
	variant="brand"
	on:click={() => {
		phg.capture('twitter_banner_click', {
			text_variant: variant,
		})

		toast.dismiss()
	}}
>
	{m.twitter_banner_button_text()}
</Button>
